export const packagesList = () => { return [
    {
        id:1,
        title:"پکیح پایه",
        img:'/assets/images/content.jpg',
        price:2400000,
        description:' دو میلیارد و صد میلیون تومان',
        details:[{
            m:10,
            t:5
        },{
            m:20,
            t:5
        },{
            m:50,
            t:5
        },{
            m:100,
            t:4
        },{
            m:200,
            t:4
        },{
            m:500,
            t:1
        },{
            m:1000,
            t:0
        },{
            m:2000,
            t:0
        }],
        counts:24
    },
    {
        id:2,
        title:"پکیح متوسط",
        img:'/assets/images/user.jfif',
        price:4840000,
        description:' چهار میلیارد و سیصد میلیون تومان',
        details:[{
            m:10,
            t:10
        },{
            m:20,
            t:10
        },{
            m:50,
            t:10
        },{
            m:100,
            t:5
        },{
            m:200,
            t:5
        },{
            m:500,
            t:2
        },{
            m:1000,
            t:1
        },{
            m:2000,
            t:0
        }],
        counts:43
    },
    {
        id:3,
        title:"پکیح پیشرفته",
        img:'/assets/images/body.jpg',
        price:6900000,
        description:' شش میلیارد و سیصد میلیون تومان',
        details:[{
            m:10,
            t:10
        },{
            m:20,
            t:10
        },{
            m:50,
            t:10
        },{
            m:100,
            t:8
        },{
            m:200,
            t:6
        },{
            m:500,
            t:3
        },{
            m:1000,
            t:2
        },{
            m:2000,
            t:0
        }],
        counts:49
    },
    {
        id:4,
        title:"پکیح  حرفه ای",
        img:'/assets/images/user-info.jfif',
        price:10520000,
        description:' نه میلیارد و هشتصد میلیون تومان',
        details:[{
            m:10,
            t:10
        },{
            m:20,
            t:10
        },{
            m:50,
            t:10
        },{
            m:100,
            t:10
        },{
            m:200,
            t:10
        },{
            m:500,
            t:4
        },{
            m:1000,
            t:2
        },{
            m:2000,
            t:1
        }],
        counts:57
    }
];}